module.exports = __webpack_public_path__ + "img/subfolderopen.886a2a3a.svg";